<template>
  <div class="header-container">
    <div class="header-section">
      <!--IZQUIERDA: Logo -->
      <div>
        <a href="http://myinvestor.es/" tabindex="0">
          <!-- MOVIL -->
          <img class="logo mobile-logo" src="https://cdn.myinvestor.es/public/assets/Logos/myinvestor_imagotipo.svg"
          alt="MyInvestor"  width="53" height="32">
          <!-- DESKTOP -->
          <img class="logo desktop-logo" src="https://cdn.myinvestor.es/public/assets/Logos/myinvestor.svg"
          alt="MyInvestor"  width="168" height="35">
        </a>
      </div>
      <!-- DERECHA: Botones -->
      <div style="display: flex;">
        <button class="button tertiary rounded" @click="loginClick">
          Inicia sesión
        </button>
        <button class="button primary rounded" @click="signupClick" >
          Hazte cliente
        </button>
      </div> 
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MYHeader',
    data() {
      return {
        menuOpen: false,
      }
    },
    methods: {
      toggleMenu() {
        this.menuOpen = !this.menuOpen;
      },
      loginClick(){
        window.location.href = 'https://newapp.myinvestor.es/auth/signin';
      },
      signupClick() {
        window.location.href = 'https://newapp.myinvestor.es/auth/signup/intro/?data_traffic_origin=Landing_helloteca&data_trigger=Header_cta_Apertura';
      }
    }
  }
</script>

<style scoped>
  .header-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    /*height: var(--header-height);*/
    z-index: 10;
    background-color: var(--white);
  }
  .header-section {
    background-color: var(--white);
    transition: var(--transition);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    padding: 20px 30px; 
    max-width: 1140px;
  }
  /* DERECHA */
  .button {
    padding: 14px 16px;
    font-family: "Avenir Next", sans-serif;
  }
  .button+.button {
    margin-left: 32px;
  }
  /* IZQ */
  .logo {
    width: 170px;
    max-width: 100%;
  }
  img {
    border-style: none;
  }
  .desktop-logo {
    display: block;
  }
  .mobile-logo {
    display: none;
  }

  /* MOVIL */
  @media (max-width: 768px){
    .header-section {
      margin: 0 auto; 
      padding: 16px 30px; 
    }
    .logo {
      width: 53px;
    }
    .desktop-logo {
      display: none;
    }
    .mobile-logo {
      display: block;
    }
    .button.tertiary {
      display: none;
    }  
  }
  /* TABLET */
  @media (min-width: 768px) and (max-width: 992px) {
    .header-section {
      width: 90%;
      margin: 0 auto;
      padding: 18px 30px; 
    }
  }
  /* ESCRITORIO*/
  @media (min-width: 993px) {
    .header-section {
      padding: 20px 30px; 
    }
  }
</style>
